import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './styles/theme.css';
import './styles/chunk.css';
import './styles/collection.css';
import './styles/product-template.css';
import './styles/product-page.css';
import './styles/news-hub.css';
import './styles/base.css';
import './styles/custom.css';
import App from './App';
import { SettingsProvider } from './context/SettingsContext';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { UIProvider } from './context/UIContext';

// Note: React.StrictMode is intentionally not used here.
// react-helmet (v6) applies its side effects from UNSAFE_componentWillMount, which React 19's
// StrictMode double-invoke discards for every tag except <title>. With StrictMode on, the
// meta/link/JSON-LD tags never reach <head> and the site loses its SEO markup.
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
      <SettingsProvider>
        <AuthProvider>
          <CartProvider>
            <UIProvider>
              <App />
            </UIProvider>
          </CartProvider>
        </AuthProvider>
      </SettingsProvider>
    </BrowserRouter>
);
